<template>
  <section class="section-base form-base">
    <template v-if="loaded">
      <AddStatementHeader
        :title="title"
        :steps-count="stepsCount"
        :current-step="1"
      />

      <AddStApplicant :add-statement="addStatement" @save="saveHandler">
        <template #footer="{ next, isSaveLoading }">
          <Footer
            class="mt-6"
            first-step
            :loading-next="isSaveLoading"
            @next-btn-click="next"
          />
        </template>
      </AddStApplicant>
    </template>
    <SkeletonLoader v-if="loading" />
    <SignatureComponent />
  </section>
</template>

<script>
import Footer from '@/components/services/elements/Footer';
import AddStApplicant from '@/views/alternativeServices/AddStApplicant/AddStApplicant';
import { mapStatementName } from '@/utils/services';
import { AddStModule } from '@/store/modules/alternativeServices/additionalStatement';
import { BreadCrumbsModule } from '@/store/modules/breadCrumbs';
import { RouteName } from '@/router';
import SkeletonLoader from '@/components/base/SkeletonLoader';
import AddStatementHeader from '@/views/alternativeServices/AddStatementHeader';
import {
  addDocumentsStepsCount,
  addDocumentsWithEdit,
  getAddDocumentsBreadcrumbs,
} from '@/utils/common';
import SignatureComponent from '@/components/base/SignatureComponent';

export default {
  name: 'AddDocumentsApplicant',
  props: {
    altStatementId: {
      type: String,
      required: true,
    },
  },
  components: {
    Footer,
    AddStApplicant,
    SkeletonLoader,
    AddStatementHeader,
    SignatureComponent,
  },
  computed: {
    title() {
      return mapStatementName[this.addStatement.originalStatementType];
    },

    stepsCount() {
      return addDocumentsStepsCount(this.withEdit);
    },

    withEdit() {
      return addDocumentsWithEdit(this.addStatement);
    },

    addStatement() {
      return AddStModule.addStatement.entity;
    },

    loading() {
      return AddStModule.addStatement.loading;
    },
    loaded() {
      return AddStModule.addStatement.loaded;
    },
  },
  async created() {
    await AddStModule.getAddStById(this.altStatementId);

    BreadCrumbsModule.SET(
      getAddDocumentsBreadcrumbs(this.addStatement.originalStatementId)
    );
  },
  beforeDestroy() {
    BreadCrumbsModule.SET(null);
  },
  methods: {
    saveHandler() {
      const nextRouteName = this.withEdit
        ? RouteName.ADD_DOCUMENTS_EDIT
        : RouteName.ADD_DOCUMENTS_SIGN;

      this.$router.push({
        name: nextRouteName,
        params: {
          altStatementId: this.altStatementId,
        },
      });
    },
  },
};
</script>
